var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconRocket = function SvgIconRocket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 9a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.9 1.08a1.73 1.73 0 0 1 2.204.004c.948.772 3 2.685 4.137 5.641.378.983.65 2.07.752 3.255l2.787 3.344a1.71 1.71 0 0 1 .36 1.509l-1.151 5.21v.004a1.75 1.75 0 0 1-2.8.984L14.648 19H9.351l-2.54 2.031a1.753 1.753 0 0 1-2.4-.204 1.75 1.75 0 0 1-.4-.78v-.003l-1.151-5.21a1.71 1.71 0 0 1 .36-1.51l2.73-3.27c.096-1.215.374-2.33.764-3.336C7.863 3.762 9.94 1.85 10.9 1.081m5.125 9.424a1 1 0 0 1-.01-.154 9.9 9.9 0 0 0-.64-2.907c-.903-2.345-2.508-3.94-3.376-4.677-.878.73-2.508 2.328-3.42 4.677a9.7 9.7 0 0 0-.655 3.084C7.84 12.37 8.261 14.53 9.588 17h4.819c1.303-2.48 1.71-4.647 1.618-6.496m3.138 4.004-1.281-1.538c-.232 1.48-.738 3.074-1.606 4.77l1.847 1.478zm-13.08-1.493-1.247 1.493 1.04 4.71 1.843-1.474c-.878-1.68-1.394-3.26-1.636-4.729",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 21.375a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2h-3a1 1 0 0 1-1-1"
  }))));
};
export default SvgIconRocket;